import axios from "axios";

/* ================= CONFIG ================= */
const BASE_URL = process.env.REACT_APP_API_URL || "/api";

/* ================= AXIOS INSTANCE ================= */
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

/* ================= REQUEST INTERCEPTOR ================= */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ================= RESPONSE INTERCEPTOR ================= */
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      console.warn("Unauthorized request");

      const originalRequest = error.config;
      const refreshToken = localStorage.getItem("refreshToken");

      if (refreshToken && !originalRequest._retry && originalRequest.url !== "/auth/refresh") {
        originalRequest._retry = true;

        try {
          const response = await api.post("/auth/refresh", { refreshToken });
          const token = response.data.token;

          if (token) {
            localStorage.setItem("token", token);
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return api(originalRequest);
          }
        } catch {
          console.warn("Token refresh failed");
        }
      }
    }

    return Promise.reject(error);
  }
);

/* ================= LOGIN ================= */
const login = async (email, password) => {
  const response = await api.post("/auth/login", {
    email,
    password,
  });

  if (response.data.token) {
    localStorage.setItem("token", response.data.token);
    if (response.data.refreshToken) {
      localStorage.setItem("refreshToken", response.data.refreshToken);
    }
    localStorage.setItem("user", JSON.stringify(response.data.user));
  }

  return response.data;
};

/* ================= GET PROFILE ================= */
const getProfile = async () => {
  return api.get("/auth/me");
};

/* ================= LOGOUT ================= */
const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
};

/* ================= GET USER ================= */
const getCurrentUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch {
    return null;
  }
};

/* ================= GET TOKEN ================= */
const getToken = () => {
  return localStorage.getItem("token");
};

const authService = {
  login,
  logout,
  getCurrentUser,
  getToken,
  getProfile,
};

export default authService;
